// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"qg","centerLink":"rg","productSection":"sg","item":"tg","ctaButton":"ug"};